<div>
  <mat-spinner></mat-spinner>
  <div class="text-15-700-dark text-center">{{ 'LOADING' | translate }}...</div>
</div>
